import { Flame, Target, Trophy } from 'lucide-react';

export const StatsBar = ({ animatedStreak, animatedScore, longestStreak, pulseScore }) => {
  return (
    <div className="grid grid-cols-3 gap-2 sm:gap-3 px-3 sm:px-4 max-w-2xl mx-auto mb-1">
      <div className="relative group transition-transform duration-300 hover:scale-105">
        <div className="absolute -inset-0.5 sm:-inset-1 bg-gradient-to-r from-lime-500 to-green-600 blur opacity-75 group-hover:opacity-100 transition"></div>
        <div className={`relative bg-black border-2 border-lime-500 px-2 sm:px-3 py-3 sm:py-4 transition-all ${pulseScore ? 'animate-score-glow' : ''} min-h-[100px] sm:min-h-[120px] flex flex-col items-center justify-center`}>
          <Flame className="text-lime-500 mb-1 flex-shrink-0" size={18} />
          <div className="text-2xl sm:text-3xl md:text-4xl font-black text-lime-500 leading-none">{animatedStreak}</div>
          <div className="text-[10px] sm:text-xs font-black text-lime-400 uppercase tracking-tight sm:tracking-wide mt-1 text-center">Day Streak</div>
        </div>
      </div>

      <div className="relative group transition-transform duration-300 hover:scale-105">
        <div className="absolute -inset-0.5 sm:-inset-1 bg-gradient-to-r from-yellow-500 to-orange-600 blur opacity-75 group-hover:opacity-100 transition"></div>
        <div className={`relative bg-black border-2 border-yellow-500 px-2 sm:px-3 py-3 sm:py-4 transition-all ${pulseScore ? 'animate-score-glow' : ''} min-h-[100px] sm:min-h-[120px] flex flex-col items-center justify-center`}>
          <Target className="text-yellow-500 mb-1 flex-shrink-0" size={18} />
          <div className="text-2xl sm:text-3xl md:text-4xl font-black text-yellow-500 leading-none">{animatedScore}</div>
          <div className="text-[10px] sm:text-xs font-black text-yellow-400 uppercase tracking-tight sm:tracking-wide mt-1 text-center">Score</div>
        </div>
      </div>

      <div className="relative group transition-transform duration-300 hover:scale-105">
        <div className="absolute -inset-0.5 sm:-inset-1 bg-gradient-to-r from-orange-500 to-red-600 blur opacity-75 group-hover:opacity-100 transition"></div>
        <div className="relative bg-black border-2 border-orange-500 px-2 sm:px-3 py-3 sm:py-4 transition-all min-h-[100px] sm:min-h-[120px] flex flex-col items-center justify-center">
          <Trophy className="text-orange-500 mb-1 flex-shrink-0" size={18} />
          <div className="text-2xl sm:text-3xl md:text-4xl font-black text-orange-500 leading-none">{longestStreak}</div>
          <div className="text-[10px] sm:text-xs font-black text-orange-400 uppercase tracking-tight sm:tracking-wide mt-1 text-center">Best Streak</div>
        </div>
      </div>
    </div>
  );
};
